import styled from "styled-components";
import LogoImg from "../../assets/LoginPage/IconLogo.png";
import Earth from "../../assets/LoginPage/globe.png";

export const Globe = styled.div`
  background-image: url(${Earth});
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: auto;
`;

export const WelcomeTitle = styled.h2`
  font-weight: 600;
  font-size: 24px;
  color: white;
  margin-top: 50px;
`;

export const LanguageButon = styled.button`
  width: 104px;
  height: 30px;
  border: solid 1px #fff;
  border-radius: 5px;
`;

export const Circle = styled.div`
  background: #ffffff;
  width: 134px;
  height: 134px;
  border-radius: 50%;
  background-image: url(${LogoImg});
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: 100px 100px;
  margin-top: 23px;
`;

export const MainContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Container = styled.div`
  background-color: #fff;
  position: relative;
  overflow: hidden;
  width: 100vw;
  max-width: 100%;
  height: 100vh;
`;

export const SignUpContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  height: 100vh;
  transition: all 0.6s ease-in-out;
  left: 0;
  width: 50%;
  opacity: 0;
  z-index: 1;
  ${(props) =>
    props.signinIn !== true
      ? `
    transform: translateX(100%);
    opacity: 1;
    z-index: 5;
  `
      : null}
`;

export const SignInContainer = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  transition: all 0.6s ease-in-out;
  left: 0;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;
  z-index: 2;
  ${(props) =>
    props.signinIn !== true ? `transform: translateX(100%);` : null}
`;

export const Form = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 50px;
  text-align: center;
`;

// export const SignInForm = styled.div`
//   width: 504px;
//   height: 491px;
//   border-radius: 10px;
//   border: 1px solid #e9e9e9;
//   background: #fff;
//   display: flex;
//   align-items: center;
//   // justify-content: space-between;
//   flex-direction: column;
//   border-radius: 10px;
//   box-shadow: 0px 0px 3.3px 0px rgba(0, 0, 0, 0.25);
// `;

export const CreateForm = styled.form`
  background-color: #ffffff;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  flex-direction: column;
  width: 606px;
  height: 690px;
  text-align: center;
  border-radius: 10px;
  box-shadow: 0px 0px 3.3px 0px rgba(0, 0, 0, 0.25);
`;

export const NaayaTradeTag = styled.h1`
  font-weight: 700;
  font-size: 40px;
  width: 250px;
`;
export const Account = styled.p`
  font-size: 18px;
  font-weigth: 500;
  font-family: "Poppins";
  width: 245px;
  heigth: 27px;
  margin-top: 38px;
`;

export const Title = styled.h1`
  font-weight: semibold;
  font-size: 24px;
  margin-top: 50px;
`;

export const Input = styled.input`
  background-color: #eee;
  border: none;
  padding: 12px 15px;
  margin: 8px 0;
  width: 100%;
`;

export const Button = styled.button`
  border-radius: 20px;
  border: 1px solid #ff4b2b;
  background-color: #ff4b2b;
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  padding: 12px 45px;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
  &:active {
    transform: scale(0.95);
  }
  &:focus {
    outline: none;
  }
`;

export const UpButton = styled.button`
  border-radius: 20px;
  border: 1px solid #ff4b2b;
  background-color: #ff4b2b;
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  transition: transform 80ms ease-in;
  &:active {
    transform: scale(0.95);
  }
  &:focus {
    outline: none;
  }
`;

export const SignInButton = styled.button`
  width: 136px;
  height: 47px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #fffbfb;
  box-shadow: 0px 0px 2.6px 1px rgba(0, 0, 0, 0.25);
  font-size: 16px;
  color: #ff6300;
  font-weight: 600;
  line-height: 24px;
  margin-top: 17px;
`;

export const GhostButton = styled(Button)`
  background-color: transparent;
  border-color: #ffffff;
`;

export const Anchor = styled.a`
  color: #333;
  font-size: 14px;
  text-decoration: none;
  margin: 15px 0;
`;
export const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: transform 0.6s ease-in-out;
  z-index: 100;
  ${(props) =>
    props.signinIn !== true ? `transform: translateX(-100%);` : null}
`;

export const Overlay = styled.div`
  background: #ff416c;
  background: -webkit-linear-gradient(to right, #ff4b2b, #ff416c);
  background: linear-gradient(to right, #ff4b2b, #ff416c);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 0;
  color: #ffffff;
  position: relative;
  left: -100%;
  height: 100%;
  width: 200%;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
  ${(props) => (props.signinIn !== true ? `transform: translateX(50%);` : null)}
`;

export const OverlayPanel = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;
  padding: 37px 40px 0 40px;
  text-align: center;
  top: 0;
  height: 100%;
  width: 50%;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
  background: linear-gradient(349.24deg, #ff6300 6.48%, #ffa165 120.82%);
`;

export const LeftOverlayPanel = styled(OverlayPanel)`
  transform: translateX(-20%);
  ${(props) => (props.signinIn !== true ? `transform: translateX(0);` : null)}
`;

export const RightOverlayPanel = styled(OverlayPanel)`
  right: 0;
  transform: translateX(0);
  ${(props) => (props.signinIn !== true ? `transform: translateX(20%);` : null)}
`;

export const SignUpPanel = styled(OverlayPanel)`
  background: linear-gradient(349deg, #ff6300 6.48%, #ffa165 120.82%);
  right: 0;
  transform: translateX(0);
  ${(props) => (props.signinIn !== true ? `transform: translateX(20%);` : null)}
`;

export const Paragraph = styled.p`
  font-size: 14px;
  font-weight: 100;
  line-height: 20px;
  letter-spacing: 0.5px;
  margin: 20px 0 30px;
`;

export const SignUpButton = styled(UpButton)`
  width: 136px;
  height: 47px;
  flex-shrink: 0;
  background-color: white;
  border-radius: 10px;
  color: #ff6300;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 17px;
  box-shadow: 0px 0px 2.6px 1px rgba(0, 0, 0, 0.25);
`;
